const popupProduct = () => {
  const popup = document.querySelector('.popup_added_to_cart');

  const handleClick = (e) => {
    const { target } = e;

    if (target.classList.contains('close') && popup) {
      e.preventDefault();
      popup.classList.add('hide');
    }
  };

  const convert = (price, qty) => {
    let total = price;

    // On traite la chaîne de caractères du prix
    total = parseFloat(total.replace(/(\d+)[\D](\d+)[\D]/g, '$1.$2'));

    // On multiplie le montant traité par la quantité de produit ajoutée au panier
    total *= parseInt(qty, 10);

    // On fixe les décimales à 2 caractères
    total = total.toFixed(2);

    // On en fait une chaîne de caractères (float -> string)
    total = total.toString();

    // On remet le montant dans le format de base (avec une virgule au lieu d'un point)
    total = `${total.replace('.', ',')}€`;

    return total;
  };

  const init = () => {
    const closingElements = document.querySelectorAll('.close');
    if (closingElements && popup) {
      closingElements.forEach(current => current.addEventListener('click', handleClick));
      const qty = popup.querySelector('.product_added .qty');
      const totals = popup.querySelectorAll('.product_added .amount');

      for (var i = 0; i < totals.length; i++) {
          totals[i].textContent = convert(totals[i].textContent, qty.textContent);
      }

    }
  };

  init();
};

export default popupProduct;